"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondsInDay = exports.LowLiquidityTokenBufferAmountsUsd = exports.LowLiquidityTokens = exports.MaxDeadline = exports.EventNames = exports.Errors = exports.PendingAmountBufferUsd = exports.LpFeeBps = exports.SettlementGasLimitPerTx = exports.BondTransferGasLimit = exports.TokenIndex = exports.HToken = exports.WrappedToken = exports.CanonicalToken = exports.Slug = exports.ChainSlug = exports.ChainName = exports.ChainId = exports.NetworkSlug = void 0;
const enums_1 = require("@hop-protocol/core/networks/enums");
Object.defineProperty(exports, "CanonicalToken", { enumerable: true, get: function () { return enums_1.CanonicalToken; } });
Object.defineProperty(exports, "ChainId", { enumerable: true, get: function () { return enums_1.ChainId; } });
Object.defineProperty(exports, "ChainName", { enumerable: true, get: function () { return enums_1.ChainName; } });
Object.defineProperty(exports, "ChainSlug", { enumerable: true, get: function () { return enums_1.ChainSlug; } });
Object.defineProperty(exports, "HToken", { enumerable: true, get: function () { return enums_1.HToken; } });
Object.defineProperty(exports, "NetworkSlug", { enumerable: true, get: function () { return enums_1.NetworkSlug; } });
Object.defineProperty(exports, "Slug", { enumerable: true, get: function () { return enums_1.Slug; } });
Object.defineProperty(exports, "WrappedToken", { enumerable: true, get: function () { return enums_1.WrappedToken; } });
var TokenIndex;
(function (TokenIndex) {
    TokenIndex[TokenIndex["CanonicalToken"] = 0] = "CanonicalToken";
    TokenIndex[TokenIndex["HopBridgeToken"] = 1] = "HopBridgeToken";
})(TokenIndex || (exports.TokenIndex = TokenIndex = {}));
var BondTransferGasLimit;
(function (BondTransferGasLimit) {
    BondTransferGasLimit["Ethereum"] = "165000";
    BondTransferGasLimit["Optimism"] = "350000";
    BondTransferGasLimit["Arbitrum"] = "2500000";
    BondTransferGasLimit["Nova"] = "2500000";
    BondTransferGasLimit["Base"] = "350000";
    BondTransferGasLimit["Linea"] = "350000";
})(BondTransferGasLimit || (exports.BondTransferGasLimit = BondTransferGasLimit = {}));
exports.SettlementGasLimitPerTx = {
    ethereum: 5141,
    polygon: 5933,
    gnosis: 3218,
    optimism: 8545,
    arbitrum: 19843,
    nova: 19843,
    base: 8545,
    zksync: 10000,
    linea: 10416,
    scrollzk: 10000,
    polygonzk: 10000 // TODO
};
exports.LpFeeBps = 4;
exports.PendingAmountBufferUsd = 50000;
var Errors;
(function (Errors) {
    Errors["NotEnoughAllowance"] = "Not enough allowance. Please call `approve` on the token contract to allow contract to move tokens and make sure you are connected to the correct network.";
    Errors["xDaiRebrand"] = "NOTICE: xDai has been rebranded to Gnosis. Chain \"xdai\" is deprecated. Use \"gnosis\" instead.";
})(Errors || (exports.Errors = Errors = {}));
var EventNames;
(function (EventNames) {
    EventNames["TransferSent"] = "TransferSent";
    EventNames["TransferSentToL2"] = "TransferSentToL2";
})(EventNames || (exports.EventNames = EventNames = {}));
exports.MaxDeadline = 9999999999;
// Low liquidity or single-chain tokens should have a buffer of appx 10% of their L1 stake
exports.LowLiquidityTokens = ['HOP', 'SNX', 'sUSD', 'rETH'];
exports.LowLiquidityTokenBufferAmountsUsd = {
    HOP: '8000',
    SNX: '40000',
    sUSD: '40000',
    rETH: '50000'
};
exports.SecondsInDay = 86400;
